/* eslint-disable i18next/no-literal-string -- styles not user facing */
import { defineSlotRecipe } from '@chakra-ui/react';

export const table = defineSlotRecipe({
  className: 'chakra-table',
  slots: ['root', 'row', 'cell', 'columnHeader', 'caption', 'footer', 'body', 'header'],

  base: {
    root: {
      background: 'none',
      borderCollapse: 'separate',
      borderSpacing: '0px',
    },
    columnHeader: {
      fontSize: 'sm',
      color: 'fg.muted',
      fontWeight: 'bold',
    },
    row: {
      _last: {
        '& td': { borderBottom: 'none' },
      },
    },
  },

  variants: {
    variant: {
      line: {
        root: {
          bg: 'bg',
        },
        row: {
          bg: 'none',
        },
      },
      minimal: {
        root: {
          bg: 'bg',
        },
        columnHeader: {
          borderBottomWidth: '0px',
        },
        cell: {
          borderBottomWidth: '0px',
        },
        row: {
          bg: 'none',
        },
      },
    },
    stickyHeader: {
      true: {
        header: {
          '& :where(tr)': {
            top: 'var(--table-sticky-offset, 0)',
            position: 'sticky',
            zIndex: 1,
          },
        },
      },
    },

    size: {
      lg: {
        root: {
          textStyle: 'md',
        },
        columnHeader: {
          px: '6',
          py: '3',
          lineHeight: '1rem',
        },
        cell: {
          px: '6',
          py: '4',
          lineHeight: '1.25rem',
        },
        footer: {
          lineHeight: '1.25rem',
        },
      },
      sm: {
        root: {
          lineHeight: '1rem',
        },
        columnHeader: {
          fontSize: 'xs',
          px: 4,
          py: 2,
          _dark: {
            fontSize: 'md',
            fontWeight: 'semibold',
            px: 3,
          },
        },
        cell: {
          px: '4',
          py: '2',
          _dark: {
            px: 3,
          },
        },
        footer: {
          px: '4',
          _dark: {
            px: 3,
          },
        },
      },
    },
  },

  defaultVariants: {
    size: 'lg',
  },
});
